import { cn } from "@/lib/utils";

const COLOR_MAP = {
  slate: "bg-slate-100 text-slate-500",
  blue: "bg-blue-50 text-blue-600",
  amber: "bg-amber-50 text-amber-600",
  green: "bg-emerald-50 text-emerald-600",
  red: "bg-red-50 text-red-600",
  primary: "bg-primary/10 text-primary",
};

/**
 * A single stat tile — icon badge, big number, small uppercase label.
 * Designed to live inside a <StatGroup>, but works standalone too.
 */
export function StatCard({ label, value, icon: Icon, color = "slate", accent = false, testId }) {
  return (
    <div data-testid={testId} className="flex-1 min-w-[140px] px-5 py-1 first:pl-0 last:pr-0">
      <div
        className={cn(
          "w-9 h-9 rounded-lg flex items-center justify-center mb-3",
          COLOR_MAP[accent ? "primary" : color]
        )}
      >
        {Icon ? <Icon size={16} /> : <span className="w-1.5 h-1.5 rounded-full bg-current" />}
      </div>
      <p className="text-3xl font-extrabold tracking-tight leading-none">{value}</p>
      <p className="kicker mt-2">{label}</p>
    </div>
  );
}
